import React from 'react';

const GeneralInfoIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 1.33334H2.66667C1.93029 1.33334 1.33333 1.93029 1.33333 2.66667V10.6667C1.33333 11.403 1.93029 12 2.66667 12H4V14.6667C4 14.8507 4.09511 15.0213 4.24765 15.1161C4.32037 15.1609 4.40269 15.1833 4.48501 15.1833C4.58453 15.1833 4.68357 15.1506 4.76629 15.0867L7.79093 12H13.3333C14.0697 12 14.6667 11.403 14.6667 10.6667V2.66667C14.6667 1.93029 14.0697 1.33334 13.3333 1.33334Z"
        fill="#0265DC"
      />
    </svg>
  );
};

export default GeneralInfoIcon;
